import { io } from "socket.io-client";
import { getApiBaseUrl } from "./Api";
import { tokenManager } from "./tokenManager";

let socketSingleton = null;
let socketRole = null;

/** Drop the shared Socket.IO client (call on logout so presence goes offline). */
export function resetSocketConnection() {
  if (socketSingleton) {
    try {
      socketSingleton.removeAllListeners();
    } catch (_) {}
    try {
      socketSingleton.disconnect();
    } catch (_) {}
  }
  socketSingleton = null;
  socketRole = null;
}

export function getSocket({ role } = {}) {
  const uiPath = (() => {
    try {
      return String(window?.location?.pathname || "").toLowerCase();
    } catch (_) {
      return "";
    }
  })();
  const requestedRole = String(role || "").toLowerCase();
  const normalizedRole =
    uiPath.startsWith("/hospital") && requestedRole === "doctor"
      ? "hospital"
      : requestedRole;
  const token =
    normalizedRole === "doctor"
      ? tokenManager.getTokenForRole("doctor")
      : normalizedRole === "hospital"
        ? tokenManager.getTokenForRole("hospital")
      : normalizedRole === "admin"
        ? null
        : tokenManager.getTokenForRole("patient");

  if (!token) {
    if (socketSingleton && socketRole === normalizedRole) {
      resetSocketConnection();
    }
    return null;
  }

  // If role changed, recreate socket with correct token.
  if (socketSingleton && socketRole && socketRole !== normalizedRole) {
    try {
      socketSingleton.disconnect();
    } catch (_) {}
    socketSingleton = null;
    socketRole = null;
  }

  if (socketSingleton) return socketSingleton;

  try {
    socketRole = normalizedRole;
    socketSingleton = io(getApiBaseUrl(), {
      transports: ["websocket", "polling"],
      auth: { token },
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 500,
    });
    return socketSingleton;
  } catch (_) {
    socketSingleton = null;
    socketRole = null;
    return null;
  }
}

